import { RouteObject } from "react-router"
import AtendimentoList from "./view/atendimento.list"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../config/data.types"
import { SentimentVerySatisfied } from "@mui/icons-material"
import store from "../../store"
import { atendimentoController } from "./atendimento.controller"

export enum PathRotaAtendimento {
    atendimento = "/atendimento"
}

const routerAtendimento: RouteObject = {
    path: PathRotaAtendimento.atendimento,
    element: <AtendimentoList/>,
}


export const navigationToAtendimentoView = ()=> rotas.navigate(PathRotaAtendimento.atendimento)

export function startRouterAtendimento(){
    const menu:MainMenu = {
        text:"Atendimentos",
        icon:<SentimentVerySatisfied />,
        eventOnClick:navigationToAtendimentoView
    }
    menuRotas.push(menu);
    return routerAtendimento
}

export const handleRealizarTratamentoDispatch = () => {
    store.dispatch(atendimentoController.reducer.actions.handleRealizarTratamento())
}

export const handleCancelarTratamentoDispatch = () => {
    store.dispatch(atendimentoController.reducer.actions.handleCancelartratamento())
}

export const handleShowCadTratamentoDispatch = (tratamento_id: string) => {
    store.dispatch(atendimentoController.reducer.actions.setShowModalCadTratamento(true, 0))
}